import { render, staticRenderFns } from "./TeacherStudents.vue?vue&type=template&id=fec8270a&scoped=true&"
import script from "./TeacherStudents.vue?vue&type=script&lang=js&"
export * from "./TeacherStudents.vue?vue&type=script&lang=js&"
import style0 from "./TeacherStudents.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TeacherStudents.vue?vue&type=style&index=1&id=fec8270a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec8270a",
  null
  
)

export default component.exports